module.exports = __webpack_public_path__ + "school/img/practiceGxThemeBg.faeb6a0b.jpg";